import React from 'react'
import { useNotFound } from 'hooks/useNotFound'
import { NotFoundTemplate } from 'components/templates/NotFoundTemplate'

export const NotFoundView = () => {
  const { main1, main2, sub1, sub2 } = useNotFound()
  return <NotFoundTemplate main1={main1} main2={main2} sub1={sub1} sub2={sub2} />
}
